import React from 'react'
import PropTypes from 'prop-types'

import config from '../config'

import Logo from '../../../modules/crm/images/brand/crm-logo.svg'

import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import MomentUtils from '@date-io/moment'

import moment from 'moment'

// Authentication
import { AuthenticationContainer } from 'authentication_alias'
import { setHandle401RequestCallback } from '@eig-builder/core-utils/helpers/fetch-helper'

import Bootstrapper from '@eig-builder/module-bootstrapper'

// helpers
import { DrawerContext, AccountContext } from '@eig-builder/module-navigation'

// Events api
import EventsContainer from '@eig-builder/module-application-events'

// Routes
import { Routes as CrmRoutes, Reducers as CrmReducers } from 'modules/crm'
// import { Routes as AccountRoutes, Reducers as AccountReducers } from 'modules/account'
import { Routes as ManagementRoutes, Reducers as ManagementReducers } from 'modules/management-portal'
import { Routes as TranslationRoutes, Reducers as TranslationToolReducers } from 'modules/translations'

// Register PropertyEditor additional fields
import { PropertyEditorContext } from '@eig-builder/module-property-editor'
import Select from '@eig-builder/module-property-editor-field-select'
import MultiSelect from '@eig-builder/module-property-editor-field-multiselect'

import RefreshIntervalContextWrapper from 'core/context/refresh-interval'

import '@eig-builder/core-utils/base-style/main.scss'

import * as GlobalStore from '@eig-builder/core-utils/store'
import { getMenuItems, getAccountMenuItems } from './menu-items'

import 'react-dates/initialize'
import apiMiddleware from 'core/api-middleware'

import { setRuntimeConfig, getRuntimeConfig } from '@eig-builder/core-utils/helpers/runtime-config-helper'
import { getAppSpecificUrls } from './app-urls'

const customRuntimeConfig = { ...getRuntimeConfig() }

customRuntimeConfig._brandImages.BrandLogoSVG = Logo
customRuntimeConfig._urls = {
  ...customRuntimeConfig._urls,
  ...getAppSpecificUrls(customRuntimeConfig._env)
}

setRuntimeConfig(customRuntimeConfig)

moment.updateLocale(moment.locale(), { invalidDate: '-' })

const routes = [
  ManagementRoutes,
  TranslationRoutes,
  CrmRoutes // Contains the default route, should be the last one
]

const store = GlobalStore.create(config, [ManagementReducers, CrmReducers, TranslationToolReducers], [apiMiddleware])

store.dispatch({
  type: 'AVAILABLE_ROUTES',
  payload: routes
})

const drawer = {
  menuItems: getMenuItems(store.getState())
}

function handleMenuItemChange (unsubscribe) {
  drawer.menuItems = getMenuItems(store.getState(), unsubscribe)
}

const unsubscribe = store.subscribe(() => handleMenuItemChange(unsubscribe))

const accountMenu = getAccountMenuItems()

setHandle401RequestCallback(() => {
  window.location.href = '/login'
})

const BaseRouterWrapper = props => (
  <AuthenticationContainer>
    <EventsContainer>
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <DrawerContext.Provider value={drawer}>
          <AccountContext.Provider value={accountMenu}>
            <PropertyEditorContext.Provider value={{ additionalFieldTypes: [Select, MultiSelect], skeletonLoader: true }}>
              <RefreshIntervalContextWrapper>
                {props.children}
              </RefreshIntervalContextWrapper>
            </PropertyEditorContext.Provider>
          </AccountContext.Provider>
        </DrawerContext.Provider>
      </MuiPickersUtilsProvider>
    </EventsContainer>
  </AuthenticationContainer>
)

BaseRouterWrapper.propTypes = { children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]) }

export default () => (
  <Bootstrapper
    routes={routes}
    defaultRoute='/'
    basename=''
    store={store}
    loginUrl='/login'
    BaseRouterWrapper={BaseRouterWrapper}
    AuthenticationContainerProps={{
      shouldLoadBillingInfo: false,
      shouldLoadBillingPendingOrders: false,
      shouldLoadAccountInfo: true
    }}
  />
)
